import React from 'react';

export default function NZSPGAccessCodeModal() {
  return null;
}
